import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGS, isSupportedLang, type SupportedLang } from '../../i18n'
import { useUpdatePreferredLanguage } from '../../hooks/api/usePreferredLanguage'
import { cn } from '../../lib/utils'

interface AppLanguageSwitcherProps {
  className?: string
  size?: 'sm' | 'md'
}

export function AppLanguageSwitcher({ className, size = 'sm' }: AppLanguageSwitcherProps) {
  const { i18n, t } = useTranslation('common')
  const mutation = useUpdatePreferredLanguage()

  const active: SupportedLang = isSupportedLang(i18n.language) ? i18n.language : 'fr'

  const handleSwitch = (lang: SupportedLang) => {
    if (lang === active || mutation.isPending) return
    mutation.mutate(lang)
  }

  return (
    <div className={cn('flex items-center', className)} role="group" aria-label={t('languages.fr')}>
      {SUPPORTED_LANGS.map((lang, index) => {
        const isActive = lang === active
        return (
          <span key={lang} className="flex items-center">
            {index > 0 && <span className="text-border mx-1">·</span>}
            <button
              type="button"
              onClick={() => handleSwitch(lang)}
              disabled={mutation.isPending}
              className={cn(
                'rounded font-medium uppercase transition-colors disabled:opacity-60',
                size === 'sm' ? 'px-1 py-0.5 text-11' : 'px-2 py-1 text-13',
                isActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'
              )}
              aria-pressed={isActive}
            >
              {lang}
            </button>
          </span>
        )
      })}
    </div>
  )
}
